import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Product } from '../../shared/api/model/product';
import { Partner } from '../../shared/api/model/partner';
import {AgentService} from '../../shared/api/resources/agent/agent.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit, OnDestroy {
  private _activityTypeFilter: number;
  private _products: Array<Product>;
  private _filteredProducts: Array<Product>;
  private _sub: any;
  partnerId: number;
  partner: Partner;
  activityTypes: any = [{label: 'All', value: null}];
  durations: any = [{label: 'All', value: null}];
  paxs: any = [{label: 'All', value: null}];
  productsLoading = false;


  constructor( private _route: ActivatedRoute,
               private _router: Router,
               private _agentService: AgentService) { }

  ngOnInit() {
    
    this._sub = this._route.params.subscribe(params => {
      this.partnerId = parseInt(params['id'], 10);
      this.productsLoading = true;
      this._agentService.getAgentResumeToSupplier(this.partnerId).subscribe(
        (res: any) => {
          const partner = res.suppliers[0];
          this._products = partner.products;
          this._filteredProducts = this._products.map(x => Object.assign({}, x));
          // Populate durations and paxs
          for (const product of this._products) {
            // prepare labels
            const durationLabel = parseInt( product.duration ? product.duration.split(':')[0] : '0', 10) + ' hours';
            const paxLabel = product.capacity.toString();

            // check labels already exist
            let containsDuration = false;
            let containsPax = false;

            for (const duration of this.durations) {
              if (duration.label === durationLabel) {
                containsDuration = true;
                break;
              }
            }

            for (const pax of this.paxs) {
              if (pax.label === paxLabel) {
                containsPax = true;
                break;
              }
            }

            // push new entries if they don't exist
            if (!containsDuration) {
              this.durations.push({label: durationLabel, value: product.duration});
            }

            if (!containsPax) {
              this.paxs.push({label: paxLabel, value: product.capacity});
            }
          }

          const compareFn = (a, b) => {
            if (a.value < b.value) {
              return -1;
            }
            if (a.value > b.value) {
              return 1;
            }
            return 0;
          };
          this.durations.sort(compareFn);
          this.paxs.sort(compareFn);

          this.activityTypes = [{ label: 'All', value: null }];
          const categoryIds = new Set<number>();
          for (const product of this._products) {
            if (product.categoryList && Array.isArray(product.categoryList)) {
              for (const category of product.categoryList) {
                if (!categoryIds.has(category.id)) {
                  categoryIds.add(category.id);
                  this.activityTypes.push({ label: category.name, value: category.id });
                }
              }
            }
          }

          this.partner = partner.supplier;
        },
        undefined,
        () => {
          this.productsLoading = false;
        }
      );
    });
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  public goToProductEvents(id: number) {
    this._router.navigate(['../product-events/' + id], { relativeTo: this._route });
  }

  private _filterProducts() {
    this.productsLoading = true;
    this._filteredProducts = [];
    for (const product of this._products) {
      let activityCheck = false;

      if (
        this._activityTypeFilter === null ||
        this._activityTypeFilter === undefined ||
        product.categoryList.some(category => category.id ===this._activityTypeFilter)
      ) {
        activityCheck = true;
      }

      if (activityCheck) {
        this._filteredProducts.push(product);
      }
    }
    this.productsLoading = false;
  }


  get products(): Array<Product> {
    return this._filteredProducts;
  }

  set products(value: Array<Product>) {
    this._filteredProducts = value;
  }

  set activityTypeFilter(value: number) {
    if (this._activityTypeFilter !== value) {
      this._activityTypeFilter = value;
      this._filterProducts();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/experiences/products/products.component.ts